module.exports = __webpack_public_path__ + "static/Ruckers-968c1d62f442661ae775fd566aafe61e.png";